import { render, staticRenderFns } from "./LicensorViewComponent.vue?vue&type=template&id=f84e3b34&scoped=true&lang=pug&"
import script from "./LicensorViewComponent.vue?vue&type=script&lang=coffee&"
export * from "./LicensorViewComponent.vue?vue&type=script&lang=coffee&"
import style0 from "./LicensorViewComponent.vue?vue&type=style&index=0&id=f84e3b34&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84e3b34",
  null
  
)

export default component.exports